module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "pt1",
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Part-Number-pn",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART I")])])]), _vm._v(" "), _c('h1', {
    staticClass: "Part-Title-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW TO MAKE A MILLIONAIRE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-non-verse-pepi"
  }, [_c('i', [_vm._v("The only way to do great work is to love what you do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-Source-peps"
  }, [_c('i', {
    staticClass: "part-epigraph-source-peps-_span-italic-characters-ital"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "pepc_CAPS"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDÉ")]), _vm._v(" "), _c('span', {
    staticClass: "pepc_CAPS"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST (AND LATER,")]), _vm._v(" "), _c('span', {
    staticClass: "pepc_CAPS"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEVE")]), _vm._v(" "), _c('span', {
    staticClass: "pepc_CAPS"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBS)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 78
// module chunks = 0